import {useEffect, useState } from "react";
import EmailLogin from './EmailLogin'
import SignUp from './SignUp'
import AuthLoadingCard from "../../../components/unauth/AuthLoadingCard"
import { useLoadAuthUser } from "../../../hooks/authhooks";


const Login = () => {

  const [isSignUp, setIsSignUp] =  useState(false)
    var { registerUser, registerBusiness,isLoading } = useLoadAuthUser()


    useEffect(()=> {
        document.title = 'Partner Dashboard | Sign In'
     }, [])  
     
     if (isLoading){
      return (
        <AuthLoadingCard />
      )
    } else {
      return (isSignUp) ? <SignUp registerBusiness={registerBusiness} toggleSignIn={() => setIsSignUp(false)} /> : <EmailLogin registerUser={registerUser} toggleSignUp={() => setIsSignUp(true)} />
    }
 
}




export default Login
